// The first list index in `path` that `_set` would write past the end of its list in `data`, or
// null when every index stays in range. Writing fields[4].required into a 2-entry list pads it
// with empty slots; a whole new entry at exactly the end (fields[2] on a 2-entry list) is an
// append, not a gap, so it passes.
export const findIndexPastListEnd = (data, path) => {
  const segments = _toPath(path);
  let node = data;

  for (const [position, segment] of segments.entries()) {
    // A missing list is one `_set` would create, so it counts as empty.
    const length = Array.isArray(node) ? node.length : node == null ? 0 : null;
    const index = Number(segment);
    if (length !== null && /^\d+$/.test(segment)
      && (index > length || (index === length && position < segments.length - 1))) {
      return { listPath: segments.slice(0, position).join('.'), index, length };
    }
    node = node?.[segment];
  }

  return null;
};
